commonModule.factory('imSessionVarsService', ['$http', 'AppSettings', '$window', function ($http, AppSettings, $window) {
    var imSessionVarsSvc = {};

    imSessionVarsSvc.setCurrentIMUser = function(user) {
        $window.sessionStorage.setItem('SESS_IM_USER', JSON.stringify(user));
    };

    imSessionVarsSvc.getCurrentIMUser = function() {
        return JSON.parse($window.sessionStorage.getItem('SESS_IM_USER'));
    };

    imSessionVarsSvc.setCurrentIMUserRoles = function(claims) {
        var userRoles = claims.map(function(claim) {
            return claim.Value.toUpperCase();
        });
        $window.sessionStorage.setItem('SESS_IM_USER_ROLES', JSON.stringify(userRoles));
    };

    imSessionVarsSvc.getCurrentIMUserRoles = function() {
        return JSON.parse($window.sessionStorage.getItem('SESS_IM_USER_ROLES'));
    };

    imSessionVarsSvc.setCurrentProviderSettings = function(settings) {
        /*var providerSettings = settings.map(function(setting) {
            return setting.Value;
        });*/
        $window.sessionStorage.setItem('SESS_IM_PROVIDER_SETTINGS', JSON.stringify(settings));
    };

    imSessionVarsSvc.getCurrentProviderSettings = function(setting) {
        var settings = JSON.parse($window.sessionStorage.getItem('SESS_IM_PROVIDER_SETTINGS'));
        var found = null;
        if (settings) {
            for (var i = 0; i < settings.length; i++) {
                var element = settings[i];
                if (element.SettingKey === setting) {
                    found = element;
                    break;
                }
            }
        }
        //var found =  _.find(settings, function(element) {  return element.SettingKey == setting; });
        if (found) {
            // note: defaultValue could exist as property, but have value of undefined
            return found.SettingValue;
        } else {
            // There was no kv pair for this feature on this provider, and no default was given either
            return null;
        }
    };

    imSessionVarsSvc.setRolesAndPrivileges = function(roles){
        $window.sessionStorage.setItem('SEES_IM_ROLES_PRIVILEGES', roles);
    };

    imSessionVarsSvc.getRolesAndPrivileges = function(){
        return JSON.parse($window.sessionStorage.getItem('SEES_IM_ROLES_PRIVILEGES'));
    };

    imSessionVarsSvc.getCurrentProviderCode = function() {
        var prov = $window.sessionStorage.getItem('SESS_PROVIDER_CODE');
        return prov;
    };

    imSessionVarsSvc.setCurrentProviderCode = function(providerCode) {
        $window.sessionStorage.setItem('SESS_PROVIDER_CODE', providerCode);
    };

    /*imSessionVarsSvc.getCurrentProviderUIRequiredAccess = function() {
        return  $window.sessionStorage.getItem('SESS_PROVIDER_REQUIRED_ACCESS');
    };

    imSessionVarsSvc.setCurrentProviderUIRequiredAccess = function(elements) {
        $window.sessionStorage.setItem('SESS_PROVIDER_REQUIRED_ACCESS', elements);
    };*/

    imSessionVarsSvc.getCurrentProviderId = function() {
        var providerId  = $window.sessionStorage.getItem('SESS_PROVIDER_ID');
        if(!providerId) {
            //don't hard-code the provider Id!!
            providerId = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        }

        return providerId;
    };

    imSessionVarsSvc.setCurrentProviderId = function(providerId) {
        $window.sessionStorage.setItem('SESS_PROVIDER_ID', providerId);
    };

    imSessionVarsSvc.getCurrentDealerIMId = function() {
        var dealerId  = $window.sessionStorage.getItem('SESS_DEALER_ID');

        return dealerId;
    };

    imSessionVarsSvc.setCurrentDealerIMId = function(dealerId) {
        $window.sessionStorage.setItem('SESS_DEALER_ID', dealerId);
    };

    imSessionVarsSvc.getProductPricingPortalId = function() {
        var pppId  = $window.sessionStorage.getItem('SESS_PPP_ID');

        return pppId;
    };

    imSessionVarsSvc.setProductPricingPortalId = function(pppId) {
        $window.sessionStorage.setItem('SESS_PPP_ID', pppId);
    };

    imSessionVarsSvc.getCurrentDealerIMName = function() {
        var dealerName  = $window.sessionStorage.getItem('SESS_DEALER_NAME');

        return dealerName;
    };

    imSessionVarsSvc.setCurrentDealerIMName = function(dealerName) {
        $window.sessionStorage.setItem('SESS_DEALER_NAME', dealerName);
    };

    imSessionVarsSvc.getShowcaseIntegrated = function() {
        var showcaseIntegrated  = $window.sessionStorage.getItem('SESS_SHOWCASE_INTEGRATED');

        return showcaseIntegrated;
    };

    imSessionVarsSvc.setShowcaseIntegrated = function(showcase) {
        $window.sessionStorage.setItem('SESS_SHOWCASE_INTEGRATED', showcase);
    };

    imSessionVarsSvc.getShowcaseIntegratedSetting = function() {
        var showcaseIntegratedSetting  = $window.sessionStorage.getItem('SESS_SHOWCASE_INTEGRATED_SETTING');

        return showcaseIntegratedSetting;
    };

    imSessionVarsSvc.setShowcaseIntegratedSetting = function(setting) {
        $window.sessionStorage.setItem('SESS_SHOWCASE_INTEGRATED_SETTING', setting);
    };

    imSessionVarsSvc.setRetailBelowZero = function(allowRetailBelowZero) {
        $window.sessionStorage.setItem('SESS_RETAIL_MODIFY', JSON.stringify(allowRetailBelowZero));
    };

    imSessionVarsSvc.getRetailBelowZero = function() {
        var allowRetailBelowZero  = $window.sessionStorage.getItem('SESS_RETAIL_MODIFY');

        return !(allowRetailBelowZero != null && allowRetailBelowZero != 'null') ? false : allowRetailBelowZero.toString().toUpperCase() === "TRUE";
    };

    return imSessionVarsSvc;
}]);
